var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateLayout',{attrs:{"title":"ویرایش برند","submitFunction":_vm.updateBrand}})
}
var staticRenderFns = []

export { render, staticRenderFns }